<template>
  <path
    v-if="path"
    :d="path + `V ${this.p.scaleY(this.p.minY)} H ${this.p.scaleX(p.minX)} Z`"
    :style="{
      fill: 'url(#Gradient1)',
      fillOpacity: 0.5,
    }"
  />
</template>

<script>
import * as d3Shape from "d3-shape";
export default {
  computed: {
    path() {
      var lineFunction = d3Shape
        .line()
        .x((o) => {
          return this.p.scaleX(o[this.c.xAxis]);
        })
        .y((o) => {
          return this.p.scaleY(o[this.serie.key]);
        })
        .curve(d3Shape[this.c.yAxisCurve]);

      return lineFunction(this.d);
    },
  },
  props: ["p", "c", "d", "serie"],
};
</script>
